export const PILOT_STATUS = {
  NOT_PASS: 'not_pass',
  PASSED: 'passed',
  CONFIRMING: 'confirming'
} as const;

export type PilotStatusType = typeof PILOT_STATUS[keyof typeof PILOT_STATUS];
